import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Global error handling for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled Promise Rejection:', event.reason);
});

// Basic lifecycle logging to verify app mount
console.log('OctoInk Studios main.jsx starting mount...');

const container = document.getElementById('root');
if (!container) {
    console.error('CRITICAL: Root element #root not found in the DOM!');
} else {
    createRoot(container).render(
        <App />
    )
    console.log('OctoInk Studios main.jsx mount triggered.');
}
